<template>
    <div>
        <menu-item
            v-for="item in navigationItems"
            :key="item.id"
            :label="item.label"
            :collapsed="collapsed"
            :mobile="mobile"
            :icon="item.icon"
            :icon-class="item.iconClass"
            :active-routes="item.activeRoutes"
            :to="item.route"
            :exact="item.exact"
            :badge-visible="item.id === 'tickets' && ticketBadgeVisible"
            :badge-count="ticketBadgeCount"
        ></menu-item>
    </div>
</template>

<script>
import MenuItem from "@/components/layout/workspace/menu/menu-item";
import {resolveStoreAccess} from "@/utils/access-context";
import {resolveVisibleNavigationItems} from "@/utils/navigation-items";

export default {
    name: "navigation-menu-list",
    components: {MenuItem},
    props: {
        mobile: {
            type: Boolean,
            required: false,
            default: false,
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    computed: {
        accessContext() {
            return resolveStoreAccess(this.$store);
        },
        navigationItems() {
            return resolveVisibleNavigationItems(this.accessContext);
        },
        ticketBadgeState() {
            return this.$store?.state?.badges?.tickets || {enabled: false, count: 0, source: null};
        },
        ticketBadgeVisible() {
            return !!this.ticketBadgeState.enabled && Number(this.ticketBadgeState.count || 0) > 0;
        },
        ticketBadgeCount() {
            return Math.max(0, Number(this.ticketBadgeState.count || 0));
        },
    },
}
</script>
